import React from 'react';
import { T } from '@tribeplatform/react-components/i18n';
import { RichTextPickerField } from '@tribeplatform/react-components/PickerField';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useBlock } from '../../hooks/index.js';
export const RichTextBlockSettings = () => {
    const { block: { props: { content, backgroundColor }, }, upsertProp, upsertProps, } = useBlock();
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement(RichTextPickerField, { label: React.createElement(T, { id: "Generics.Content", defaultMessage: "Content" }), value: content, name: "content", onChange: value => {
                upsertProp('content', value);
            } }),
        false && (React.createElement(FormControl.BackgroundColorPicker, { name: "backgroundColor", label: React.createElement(T, { id: "Generics.Background", defaultMessage: "Background" }), value: backgroundColor, onChange: style => {
                upsertProps({
                    backgroundColor: style === null || style === void 0 ? void 0 : style.background,
                    textColor: style === null || style === void 0 ? void 0 : style.textColor,
                });
            } }))));
};
//# sourceMappingURL=Settings.js.map